export default __webpack_public_path__ + "land-use-800-1361c95605e5ab12d234f38400eaf2d6.webp";